import script from "./ElectronicInvoicePartialReturnTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ElectronicInvoicePartialReturnTable.vue?vue&type=script&setup=true&lang=js"

import "./ElectronicInvoicePartialReturnTable.vue?vue&type=style&index=0&id=3702c0a2&lang=css"

const __exports__ = script;

export default __exports__